module.exports = __webpack_public_path__ + "img/horizontal_7_2_8003.125aea55.png";